import { render, staticRenderFns } from "./InvN.vue?vue&type=template&id=deccd4ee"
import script from "./InvN.vue?vue&type=script&lang=js"
export * from "./InvN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports